import React from "react";
import { Route, Routes } from "react-router-dom";
import { PublicTicketData } from "../../data/PublicTicketData";
import AddTicket from "../AddTicket/AddTicket";
import ListItem from "../ListItem/ListItem";
import TicketsList from "../TicketsList/TicketsList";
import { PublicTicketsMenuStyle } from "./PublicTicketsMenuStyle";

const PublicTicketsMenu = () => {
  return (
    <PublicTicketsMenuStyle>
      <ListItem items={PublicTicketData} />
    </PublicTicketsMenuStyle>
  );
};

export default PublicTicketsMenu;
